import React from 'react';
import {NeuroMessage, TransitionContainer} from "@ignitesales/neuro-application";
import {GuideNameMessage, useDialogueContext} from "../../../../../../shared/js";
import DialogueProgressBar from "../../../../../../shared/js/core-components/DialogueProgressBar";
import ProgressBarLine from "../../../../../../shared/js/core-components/ProgressBarLine";

const TexturedBar = () => {
    const { getPagePathMessageId } = useDialogueContext();
    const messageId = getPagePathMessageId();
    const componentClass = "texturedBar";

    return <div className={componentClass}>
        <div className="titleSection">
            <GuideNameMessage tagName="span" />
        </div>
        <div className="texturedSection">
            <TransitionContainer className="sidebarTransitionContainer" transitionKey={messageId}>
                <div className={`${componentClass}__text`}>
                    <NeuroMessage id={messageId} tagName="h4" shouldHideIfNotFound={true} />
                </div>
            </TransitionContainer>
            <div className={`${componentClass}__progressBar`}>
                <DialogueProgressBar ProgressBarComponent={ProgressBarLine} className={'progressBarLine--secondaryColor'} />
            </div>
        </div>
    </div>;
};

export default TexturedBar;
